<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(48)"
      :class="index == 48 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 48" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 48"
      />
      <div>安全监控</div>
    </div>
    <div
      class="button"
      @click="selectMenu(12)"
      :class="index == 12 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 12" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 12"
      />
      <div>库存区</div>
    </div>
    <div
      class="button"
      @click="selectMenu(13)"
      :class="index == 13 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 13" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 13"
      />
      <div>产品入库信息</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>
.button-footer .button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/botton.png") no-repeat center;
  background-size: 100% 100%;
  width: 200px;
  padding: 10px 0;
  color: #fff;

  cursor: pointer;
}
.button-footer .button img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.el-popover {
  background: unset;
  padding: unset;
  border: unset;
  border-radius: unset;
}
</style>
